import { useCallback } from 'react';

type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' | 'selection' | 'tension' | 'heartbeat' | 'victory' | 'countdown';

export const useHaptic = () => {
  const vibrate = useCallback((pattern: HapticPattern) => {
    // Check if vibration API is available (mobile devices)
    if (!navigator.vibrate) return;

    try {
      switch (pattern) {
        case 'light':
          navigator.vibrate(10);
          break;
        case 'medium':
          navigator.vibrate(25);
          break;
        case 'heavy':
          navigator.vibrate(50);
          break;
        case 'success':
          // Double pulse for success
          navigator.vibrate([30, 50, 30]);
          break;
        case 'warning':
          // Triple short pulse
          navigator.vibrate([20, 30, 20, 30, 20]);
          break;
        case 'error':
          // Long vibration for error/overshoot
          navigator.vibrate([100, 30, 100]);
          break;
        case 'selection':
          navigator.vibrate(15);
          break;
        case 'tension':
          // Slow building tension pulse
          navigator.vibrate([10, 100, 20, 80, 30, 60, 40]);
          break;
        case 'heartbeat':
          // Mimics heartbeat pattern - thump-thump
          navigator.vibrate([40, 80, 30, 200]);
          break;
        case 'victory':
          // Celebratory rapid pulses
          navigator.vibrate([20, 30, 20, 30, 20, 30, 50, 50, 100]);
          break;
        case 'countdown':
          // Sharp tick
          navigator.vibrate(8);
          break;
      }
    } catch (error) {
      // Fail silently if vibration not supported
      console.debug('Haptic feedback failed:', error);
    }
  }, []);

  return { vibrate };
};
